export const parseRichText = (input: string | null) => {
  type Section = {
    type:
      | 'header'
      | 'list'
      | 'plus'
      | 'text'
      | 'listDescription'
      | 'head'
      | 'stripe'
      | 'image'
    content: string
    keep: boolean
  }

  const sections: Section[] = []

  const combinedRegex =
    /(?:>Delimiter(.*?)>Delimiter)|(?:>Head(.*?)>Head)|(?:>Enum\s(.*?)\s>Enum)|(?:>EnumDescription(.*?)>EnumDescription)|(?:\+\+(.*?)\+\+)|(?:>Stripe(.*?)>Stripe)|(?:>Image(.*?)>Image)|([\s\S]+?(?=(?:>Delimiter|>Head|>Enum|>EnumDescription|\+\+|>Stripe|>Image|$)))/gs

  const addSection = (type: Section['type'], content: string) => {
    const trimmedContent = content.trim()
    sections.push({
      type,
      content: trimmedContent.replace(/>Keep</g, ''),
      keep: trimmedContent.includes('>Keep<')
    })
  }

  let match
  // eslint-disable-next-line no-cond-assign
  while ((match = combinedRegex.exec(input ?? '')) !== null) {
    if (match[1]) addSection('header', match[1])
    else if (match[2]) addSection('head', match[2])
    else if (match[3]) addSection('list', match[3])
    else if (match[4]) addSection('listDescription', match[4])
    else if (match[5]) addSection('plus', match[5])
    else if (match[6]) addSection('stripe', match[6])
    else if (match[7]) addSection('image', match[7])
    else if (match[8] && match[8].trim()) addSection('text', match[8])
  }

  return sections
}
